import { render, staticRenderFns } from "./RestartIcon.vue?vue&type=template&id=d99977c6&"
import script from "./RestartIcon.vue?vue&type=script&lang=js&"
export * from "./RestartIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports